export default function LogoImages(props) {
  return (
    <div className="techs-wrapper-logo">
      <a href={props.href} target="_blank">
        <img className="tech-logo" src={props.src} alt={props.alt}></img>
      </a>
    </div>
  );
}
